import { render, staticRenderFns } from "./TracksArtistsReadOnlyPanel.vue?vue&type=template&id=303311ea"
import script from "./TracksArtistsReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./TracksArtistsReadOnlyPanel.vue?vue&type=script&lang=js"
import style0 from "./TracksArtistsReadOnlyPanel.vue?vue&type=style&index=0&id=303311ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports